import { render, staticRenderFns } from "./Frauds.vue?vue&type=template&id=2ae15044&scoped=true"
import script from "./Frauds.vue?vue&type=script&lang=js"
export * from "./Frauds.vue?vue&type=script&lang=js"
import style0 from "./Frauds.vue?vue&type=style&index=0&id=2ae15044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae15044",
  null
  
)

export default component.exports